/**
 * File: testimonials.js.
 *
 * Import and initialize functions for Testimonials
 */

 export default {
    testimonials: document.querySelector('.js-udp-testimonials'),
	init() {
        if (this.testimonials) {
            this.render();
        }
	},
	render() {
        const source = document.querySelector('.js-data-source');
        const status = document.querySelector('.js-data-status');
        const dataSource = source.dataset.source;
        const dataStatus = status.dataset.status;
        if (dataSource === 'api') {
            if (!dataStatus) {
                this.testimonials.classList.add('udp-hidden');
            }
        }
	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
  